import { useRef } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import logo from "../../assets/cohesive-logo.png";
import BurgerAndMenu from "../burgerAndMenu/BurgerAndMenu";

const HomepageNavbar = () => {
  const pricingMenu = useRef(null);

  const pricingItems = [
    { label: "CUET", command: () => window.location.href = "/purchase" },
    { label: "GAT", command: () => window.location.href = "https://www.cohesiveminds.com/category/general-aptitude-edge1/" },
    { label: "FAD", command: () => window.location.href = "https://www.cohesiveminds.com/category/general-aptitude-edge1/" },
  ];

  return (
    <nav className="w-full bg-white shadow-md relative z-50">
      <div className="mx-5 flex justify-between items-center py-4">
        {/* Logo */}
        <NavLink to="/" className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="h-12" />
          <span className="text-[#3579b5] font-bold text-lg mt-[15px]">COHESIVE MINDS | COLLEGE QUEST</span>
        </NavLink>

        {/* Desktop Navigation */}
        <ul className="hidden lg:flex gap-6 items-center text-black font-semibold list-none">  
          
          <li className="list-none"><NavLink to="/about" className="hover:text-[#FF820F] no-underline visited:text-inherit text-black">ABOUT</NavLink></li>
          

          <li className="list-none"><NavLink to="https://www.cohesiveminds.com/p/college-quest/" className="hover:text-[#FF820F] no-underline visited:text-inherit text-black">COURSES</NavLink></li>

          {/* Pricing Dropdown */}
          <li className="list-none text-black">
            <Button 
              label="PRICING" 
              icon="pi pi-chevron-down" 
              iconPos="right"  // This moves the icon after the text
              className="p-button-text text-black hover:text-[#FF820F] p-0" 
              onClick={(e) => pricingMenu.current.toggle(e)} 
              aria-controls="pricing_menu" 
              aria-haspopup 
            />
            <Menu model={pricingItems} popup ref={pricingMenu} id="pricing_menu" />
          </li>


          <li className="list-none"><NavLink to="/contact" className="hover:text-[#FF820F] no-underline visited:text-inherit text-black">CONTACT</NavLink></li>
        </ul>

        {/* Mobile Menu */}
        <div className="lg:hidden">
          <BurgerAndMenu />
        </div>
      </div>
    </nav>
  );
};

export default HomepageNavbar;